// src/hooks/useFilteredMenu.js
import { useSelector } from "react-redux";

export function useFilteredMenuItems(menuItems = []) {
  const permMap = useSelector((state) => state.permission?.permMap ?? {});
  const status  = useSelector((state) => state.permission?.status);

  console.log("status:", status, "permMap:", permMap);

  // Still loading — return empty to avoid flash of full menu
  if (status === "loading" || status === "idle") return [];

  // Loaded — filter by enabled flag
  return menuItems?.length ==0 ? menuItems : menuItems.filter((item) => {
    if (!permMap.hasOwnProperty(item.id)) return true; // unknown menu → show by default
    return permMap[item.id]?.enabled === true;
  });
}